import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {SUMM_GRADUATES_ORIENTATION_REQUEST} from "../summGraduatesOrientationReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${SUMM_GRADUATES_ORIENTATION_REQUEST}${START}`:
            return true;
        case `${SUMM_GRADUATES_ORIENTATION_REQUEST}${SUCCESS}`:
            return false;
        case `${SUMM_GRADUATES_ORIENTATION_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};